import { Loader, Stack, Text } from "@mantine/core";
import type { LoginTr } from "../useLoginTranslations";

export interface LoginLoadingViewProps {
  isProcessingDeepLink: boolean;
  tr: LoginTr;
}

export function LoginLoadingView({ isProcessingDeepLink, tr }: LoginLoadingViewProps) {
  return (
    <Stack align="center" gap="md">
      <Loader size="xl" />
      <Text c="dimmed">
        {isProcessingDeepLink
          ? tr("login.authenticatingDeepLink", "Authenticating and redirecting...")
          : tr("login.loading", "Loading...")}
      </Text>
    </Stack>
  );
}
